export const breakpoints = {
  md: 992,
  lg: 1200,
  xlg: 1500,
};

export const mediaQueries = (key) => {
  return (style) => `@media (min-width: ${breakpoints[key]}px) { ${style} }`;
};
